module.exports = __webpack_public_path__ + "static/media/roundedshoulder_normal_left.6b83d154.png";